// src/catalog/components/CatalogEntryRow.jsx

import { useRef } from "react";
import {
  ApplicationButton,
  ApplicationSectionHeader
} from "../../components/application";
import CatalogEntryCard from "./CatalogEntryCard";

export default function CatalogEntryRow({
  title,
  entries,
  onLearnMore,
  onLaunch,
  onOpen,
  onViewAll,
  onToggleFavorite,
  onTogglePinned,
  viewAllLabel = "View all",
  layout = "carousel"
}) {
  const rowRef = useRef(null);

  if (!entries || entries.length === 0) return null;

  const isCarousel = layout === "carousel";
  const rowLabel = title || "catalog row";

  function scroll(direction) {
    if (!rowRef.current) return;

    const amount = rowRef.current.clientWidth * 0.85;

    rowRef.current.scrollBy({
      left: direction === "next" ? amount : -amount,
      behavior: "smooth"
    });
  }

  return (
    <section
      className={[
        "catalog-section",
        `catalog-section--${layout}`
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {title && (
        <ApplicationSectionHeader
          className="catalog-section__header"
          title={title}
          actions={
            <div className="catalog-section__actions">
          {onViewAll && entries.length > 0 && (
            <ApplicationButton
              size="compact"
              variant="link"
              className="catalog-section__view-all"
              onClick={() => onViewAll({ title, entries })}
            >
              {viewAllLabel}
            </ApplicationButton>
          )}

          {isCarousel && entries.length > 1 && (
              <div className="catalog-section__scroll-controls">
              <button
                type="button"
                aria-label={`Scroll ${rowLabel} left`}
                onClick={() => scroll("previous")}
              >
                ←
              </button>

              <button
                type="button"
                aria-label={`Scroll ${rowLabel} right`}
                onClick={() => scroll("next")}
              >
                →
              </button>
            </div>
          )}
            </div>
          }
        />
      )}

      <div
        ref={rowRef}
        className="catalog-section__grid"
      >
        {entries.map((entry) => (
          <CatalogEntryCard
            key={entry._id || entry.id || entry.slug}
            entry={entry}
            onLearnMore={onLearnMore}
            onLaunch={onLaunch}
            onOpen={onOpen}
            onToggleFavorite={onToggleFavorite}
            onTogglePinned={onTogglePinned}
          />
        ))}
      </div>
    </section>
  );
}
